import classNames from 'classnames';
import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import PriceFormatField from '.';

const Signed = ({
  currencyCode,
  ...props
}) => {
  const sign = 0 .toLocaleString('en-GB', {
    style: 'currency',
    currency: currencyCode || "GBP"
  }).replace(/(US|\d+\.\d+)/g, '');
  return /*#__PURE__*/React.createElement(InputGroup, {
    className: classNames('', {
      'is-invalid': props.isInvalid,
      'is-valid': props.isValid
    })
  }, /*#__PURE__*/React.createElement(InputGroup.Prepend, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, sign)), /*#__PURE__*/React.createElement(PriceFormatField, props));
};

export default Signed;